module.exports = __webpack_public_path__ + "img/US_Map.485097fc.svg";